<template>
    <div v-if="!isSimplified" class="dk-partner-promo-label tw-relative">
        <div class="dk-partner-promo-label__card tw-w-full tw-flex tw-gap-2">
            <img v-if="logoSrc" class="tw-max-w-full tw-h-12 tw-w-12 tw-p-1" :src="logoSrc" :alt="logoText">
            <dk-divider orientation="vertical" />
            <div class="dk-partner-promo-label__text tw-flex tw-flex-col tw-justify-center tw-items-start">
                <span class="dk-partner-promo-label__title tw-text-xs tw-leading-xs tw-font-bold tw-uppercase">
                    {{ promoTitle }}
                </span>
                <span class="dk-partner-promo-label__text tw-text-xs tw-leading-xs max-lg:-tw-ml-px">
                    {{ $t('dk-partner-promo-label.valid-in') }}
                    <button v-if="enableTooltipClick" class="tw-underline lg:tw-cursor-pointer" @click="openTooltip()">
                        {{ location }}
                    </button>
                    <span v-else>{{ location }}</span>
                </span>
            </div>
        </div>
        <template v-if="isTooltipOpen">
            <div
                class="dk-partner-promo-label__tooltip-overlay tw-fixed tw-top-0 tw-left-0 tw-w-full tw-h-full tw-z-[999]"
                @click="closeTooltip"
            ></div>
            <dk-notification
                class="dk-partner-promo-label__tooltip tw-absolute tw-top-full lg:-tw-right-5 tw-mt-3 tw-z-[1000] lg:tw-min-w-card-mobile"
                :class="isLandingPage ? 'max-lg:tw-left-0 max-lg:!tw-min-w-full' : 'tw-right-0'"
                :title="tooltipData.tooltipText"
                :body="tooltipBody"
                variant="tooltip"
                @dismissed="closeTooltip"
            />
        </template>
    </div>
    <div v-else class="dk-partner-promo-label-simplified">
        <span
            class="dk-partner-promo-label-simplified__title tw-text-base-subtle tw-text-xs tw-leading-xs tw-font-bold tw-uppercase"
        >
            {{ promoTitle }}
            <span class="dk-partner-promo-label-simplified__text tw-font-normal tw-normal-case tw-ml-1">
                {{ $t('dk-partner-promo-label.valid-in') }}
                <span>{{ location }}</span>
            </span>
        </span>
    </div>
</template>

<script>
import DkDivider from '@v4/common/components/atoms/DkDivider';
import DkNotification from '@v4/common/components/atoms/DkNotification';

export default {
    name: 'DkPartnerPromoLabel',
    components: {
        DkDivider,
        DkNotification,
    },
    props: {
        isPartnerPromo: {
            type: Boolean,
            default: false,
        },
        logoData: {
            type: Object,
            default: () => ({}),
        },
        tooltipData: {
            type: Object,
            default: () => ({}),
        },
        isSimplified: {
            type: Boolean,
            default: false,
        },
        showTooltip: {
            type: Boolean,
            default: true,
        },
        isLandingPage: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isTooltipOpen: false,
        };
    },
    computed: {
        logoSrc() {
            return this.logoData.url;
        },
        logoText() {
            return this.logoData.text;
        },
        logoOfficial() {
            return this.logoData.official;
        },
        location() {
            if (this.isPartnerPromo && this.tooltipData.locationList && this.tooltipData.locationList.length) {
                if (this.tooltipData.locationList.length === 1) {
                    return this.tooltipData.locationList[0];
                }

                if (this.isSimplified || !this.showTooltip) {
                    return this.tooltipBody;
                }

                const defaultLocation = this.tooltipData.locationList[0] || '';
                return `${defaultLocation} ${this.tooltipData.otherLocationsText}`;
            }

            return this.$t('dk-partner-promo-label.all-over');
        },
        promoTitle() {
            return this.isPartnerPromo ? this.tooltipData.title : this.$t('dk-partner-promo-label.official-promo');
        },
        tooltipBody() {
            if (!this.isPartnerPromo || !this.tooltipData.locationList || !this.tooltipData.locationList.length) {
                return '';
            }

            const locations = this.tooltipData.locationList;
            const allButLast = locations.slice(0, -1);
            const last = locations[locations.length - 1];

            return `${allButLast.join(', ')} ${this.$t('compare.and', 'drivek')} ${last}`;
        },
        enableTooltipClick() {
            return (
                this.isPartnerPromo &&
                this.tooltipData.locationList &&
                this.tooltipData.locationList.length > 1 &&
                this.showTooltip
            );
        },
    },
    methods: {
        openTooltip() {
            this.isTooltipOpen = true;
        },
        closeTooltip() {
            this.isTooltipOpen = false;
        },
    },
};
</script>
